module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/新技术发展-text.e663c6c0.png";